import React, {useEffect, useState} from 'react';

import ServiceAPI from "../../../services";

import TabCreate from "../TabPage";
import TableHeaderTvRange from "../../common/Elements/TvRange/TableHeaderTvRange";
import TvRangeList from "./TableList";

import {changeState} from "../../../helpersFunction/ChnageState";
import FooterPages from "../../common/Elements/FooterPages";
import SelectedItems from "../../common/Elements/SelectedItems";
import {SelectAll} from "../../../helpersFunction/SelectAllId";
import {setPageList} from "../../../helpersFunction/SetPage";
import {selectCheckBox} from "../../../helpersFunction/CheckBoxDelete";
import {OrderFieldsList} from "../../../helpersFunction/OrderFields";


const TvRangeListPage = (props) => {
  const optionsSearch = [
    { key: 'source', text: 'Название источника', value: 'source_name' },
    { key: 'name', text: 'Название', value: 'name' },
  ];

  const [orderingList, setOrderingList] = useState([]);
  const [selectedItems, setSelectedItems] = useState({selectedItems:[]});
  const [tvRanges, setTvRanges] = useState([]);
  const [tvRangesLoad, setTvRangesLoad] = useState(false);
  const [pages, setPages] = useState({
    prev: '',
    next: ''
  });
  const [search, setSearch] = useState({
    searchField: 'name',
    searchValue: ''
  });

  const service = new ServiceAPI();

  // Rewrite
  const getListTvRange = ( params ) => {
    setTvRangesLoad(false);
    setTvRanges([]);

    service.getTvRanges(params ? params : null).then(resp => {
      if (resp.data) {

        setTvRanges(resp.data.results);
        setPageList(resp, pages, setPages);
        setTvRangesLoad(true);
      }
    });
  };

  // TODO fix 2 request
  // useEffect(() => {
  //   getListTvRange(null)
  // }, []);

  const ChangePage = (params) => {
    getListTvRange(params)
  };

  //TODO change in future
  useEffect(() => {
    if (search.searchValue || orderingList) {
      let filter = {};

      if (orderingList && orderingList.length > 0) {
        filter.ordering = orderingList
      }

      if (search.searchValue) {
        filter[search.searchField] = search.searchValue
      }

      getListTvRange(filter ? filter : null);
    }
  }, [orderingList, search]);

  const handleOrderingList = (name) => {
    OrderFieldsList(orderingList, setOrderingList, name)
  };

  const onClickCheckBox = (event) => {
    selectCheckBox(event, selectedItems, setSelectedItems)
  };

  const onClickDeleteList = () => {
    service.deleteTvRangeList(selectedItems).then(resp => {
      setSelectedItems({...selectedItems, selectedItems: []});
      getListTvRange(null);
      setSearch({...search, searchValue:''})
    })
  };

  return (
      <>
        <TabCreate
            link={'/tv-range'}
            showButtonPage={true}
            showButton={true}
            showCreateButton={true}
            showListButton={true}
            pages={pages}
            onClickPage={ChangePage}
            dataLoaded={tvRangesLoad}
            optionsSearch={optionsSearch}
            OnChange={(e, {v})=> changeState("searchValue", e.target.value, search, setSearch)}
            SearchFieldChange={(e, v)=> changeState("searchField", v.value, search, setSearch)}
            onClickAllCheckBox={(e, v)=>SelectAll(tvRanges, selectedItems, setSelectedItems, "selectedItems", v.checked)}

            searchValue={search.searchValue}
        />

        <SelectedItems
            selectedItems={selectedItems.selectedItems}
            onClickCancel={()=> changeState("selectedItems", [], selectedItems, setSelectedItems)}
            onClickDeleteList={onClickDeleteList}
        />

        <TableHeaderTvRange
            handleOrderingList={handleOrderingList}
            orderingList={orderingList}
        />

        <TvRangeList
            TvRanges={tvRanges}
            TvRangeLoad={tvRangesLoad}
            onClickCheckBox={onClickCheckBox}
            selectedItems={selectedItems.selectedItems}
        />

        <FooterPages
            pages={pages}
            onClickPage={ChangePage}
            dataLoaded={tvRangesLoad}
        />

      </>
  )
};

export default TvRangeListPage;